import { createSlice } from '@reduxjs/toolkit';

import { labelsLoaded } from '../../actions/priceMatrixActions';

// Two label sets under one slice: the price matrix's own and the alternative-hotels list's.
const labelsSlice = createSlice({
  name: 'labels',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(labelsLoaded, (_state, action) => ({
      priceMatrix: action.payload.labels,
      alternativeHotels: action.payload.alternativeHotelsLabels,
    }));
  },
});

export default labelsSlice.reducer;
